import React, { useEffect, useState } from 'react';
import './Header.css';
import { db } from '../Auth/FirebaseConfig';
import { Avatar } from '@material-ui/core';
import { Link } from 'react-router-dom';

const NavbarLeft = () => {
    const [allUser, setAllUser] = useState([]);
    const [search, setSearch] = useState('');
    const [filteredUsers, setFilteredUsers] = useState([]);

    
  useEffect(() => {
    db.collection('users').onSnapshot(shot => {
      setAllUser(shot.docs.map(doc =>  doc.data()))
    //  console.log(users)
    })
    if (allUser !== undefined) {
      const finalUsers = allUser.filter(user => {
        return user.displayName.toLowerCase().indexOf(search.toLowerCase()) !== -1
      })
   //   console.log(finalUsers)
      setFilteredUsers(finalUsers)
    }
  }, [allUser,search])

  

  const updateSearchResults = (e) => {
    setSearch(e.target.value)
  }
//<Link className="search-btn mb-4" >
    return (  
        <div className="search mt-2">
            <input type="text" placeholder="Search Facebook" className="search-txt"  onChange={updateSearchResults}/>             
            <div className={`${!search && 'navSearchNo'}`}>
            {
              allUser !== undefined && ( filteredUsers.map(user => (  
                <div className='d-flex pl-2'>
                <Avatar src={user.photoURL} className="my-1"/>
                <Link to={`/${user.displayName}`}>
                    <h4 className='ml-2 mt-3'> {user.displayName}</h4>
                </Link>
                </div>
               ))
              )
            } 
            </div>
        </div>
        
    );
}; 
  
export default NavbarLeft;